export const openTransactionUrl = (txHash: string) => {
  const txUrl = process.env.NEXT_PUBLIC_TRANSACTION_URL;

  if (txHash && txUrl) {
    window.open(`${txUrl}${txHash}`, '_blank');
  }
};
